module.exports = __webpack_public_path__ + "img/sc-4-act.359e2c2d.png";